import { useEffect, useState } from 'react'

import { getBaseState, transformEventDataToFormState } from '../helpers'

const getBuildingBaseState = (t) => ({
  building: null,
  eventType: null,
  trainer: null,
  eventName: '',
  description: '',
  location: '',
  guestsAmount: 0,
  eventCapacity: 10,
  eventPrice: 0,
  askForPostEventReview: false,
  positiveReviewFollowup: false,
  socialLinkService: null,
  setupAutomatedReminders: false,
  collectRSVP: false,
  collectGuestInformation: false,
  rsvpd: false,
  rsvpdTime: null,
  nonRsvpd: false,
  nonRsvpdTime: null,
  signUpLink: '',
  schedulerType: { value: 'none', label: t('create-event:helpers.frequencyOptions.doesNotRepeat') },
  image: undefined,
  pdf: undefined,
  imagesDatabaseOpen: false,
  householdMembersAllowed: false,
})

export const useGetBuildingFormState = (eventData, editMode, buildingId, buildingOptions, t) => {
  const [formState, setFormState] = useState(() =>
    editMode ? transformEventDataToFormState(eventData) : getBaseState(getBuildingBaseState(t)),
  )
  const { building } = formState

  useEffect(() => {
    if (!building && buildingId) {
      setFormState((prev) => ({
        ...prev,
        building: buildingOptions.find((buildingToFind) => buildingToFind.id === buildingId),
      }))
    }
  }, [buildingOptions, buildingId, building])

  return [formState, setFormState]
}
